import {
    SET_LOADING,
    GET_BRANCHES,
    BRANCH_INPUT_CHANGE,
    GET_SINGLE_BRANCH,
    SET_PAGE,
    CLEAR_BRANCH,
    SEARCH_INPUT,
    BRANCH_SELECT_COUNTRY,
    BRANCH_HANDLE_MOBILE,
    BRANCH_ADD_FILE,
    BRANCH_REMOVE_FILE,
    BRANCH_UPDATE_FILE,
    SET_MINI_LOADING,
    DATE_FILTER_INPUT,
    BRANCH_UPLOADS_TO_REMOVE,
    SORT_BY_COLUMN,
    GET_ROWS_TO_DELETE,
    SET_ROW_CHECKED,
    BRANCH_HISTORY_DATE_INPUT_CLEAR,
    BRANCH_GET_UPLOADED_FILES,
    SET_DYNAMIC_LOADING,
    BRANCH_CLEAR_UPLOAD,
    BRANCH_SET_USER_OPTIONS,
    BRANCH_AUTO_FILL,
} from '../../types';

import { ToastSuccess, ToastDanger } from '../../../Services/_toast.service';
import $ from 'jquery';
import { BranchService } from './_service.branch';
import { SwalWarning, SwalWarningHtml } from '../../../Services/_swal.service';
import { blockRoute, setMUIPage } from '../helper/helper.actions';
import { getNumRows } from '../../../Utils/Common';

// handle inputs
export const handleInputChange = (e) => async (dispatch) => {
    if (e.target.value) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({
        type: BRANCH_INPUT_CHANGE,
        payload: { key: e.target.name, value: e.target.value },
    });
};

// handle search input
export const handleSearchInput = (e) => async (dispatch) => {
    dispatch({ type: SEARCH_INPUT, payload: e.target.value });
};

// loading
export const setLoading = (status) => async (dispatch) =>
    dispatch({ type: SET_LOADING, payload: status });
export const setMiniLoading = (status) => async (dispatch) =>
    dispatch({ type: SET_MINI_LOADING, payload: status });

// clear data
export const clearBranch = () => async (dispatch) =>
    dispatch({ type: CLEAR_BRANCH });

export const branchClearUpload = () => async (dispatch) =>
    dispatch({ type: BRANCH_CLEAR_UPLOAD });

// set page
export const setPage =
    (page, status = true) =>
    async (dispatch) => {
        dispatch({ type: SET_PAGE, payload: { page, status } });
    };

// country select
export const handleSelectCountry = (selectOption) => async (dispatch) => {
    if (selectOption) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({ type: BRANCH_SELECT_COUNTRY, payload: selectOption });
};

// handle mobile
export const handleMobile = (mobile) => async (dispatch) => {
    if (mobile) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    dispatch({ type: BRANCH_HANDLE_MOBILE, payload: mobile });
};

// fetch branches
export const getBranches =
    (pageNumber, rows_per_page) => async (dispatch, getState) => {
        dispatch(setLoading(true));

        let { search, pagination, sort_order_name, sort_order_direction } =
            getState().branch;
        let rows_per_page_val =
            rows_per_page != null ? rows_per_page : getNumRows('branch') || 10;

        let searchPostParams = {
            search,
            options: {
                page: pageNumber,
                limit: rows_per_page_val,
                sort_by: sort_order_name,
                sort_order: sort_order_direction,
            },
        };

        BranchService.paginateWithSearchBranches(searchPostParams)
            .then((res) => {
                let pagination = {
                    totalCount: res.data.total_docs,
                    activePage: res.data.page,
                    itemsCountPerPage: res.data.limit,
                    totalItemsCount: res.data.total_docs,
                };

                dispatch({
                    type: GET_BRANCHES,
                    payload: {
                        branches: res.data.docs,
                        pagination: pagination,
                    },
                });
                dispatch(setLoading(false));
            })
            .catch((error) => {
                dispatch(setLoading(false));
                console.log(error);
            });
    };

// fetch single branch
export const getSingleBranch =
    (id, status = null) =>
    async (dispatch) => {
        dispatch(setMiniLoading(true));

        BranchService.getSingleBranch(id)
            .then((res) => {
                let branch = res.data.branch;

                dispatch({ type: GET_SINGLE_BRANCH, payload: branch });

                if (status == 'delete') {
                    dispatch(archive());
                }

                dispatch(setMiniLoading(false));
            })
            .catch((error) => {
                dispatch(setMiniLoading(false));
                console.log(error);
            });
    };

// store
export const branchPost = (e, pageOrigin) => async (dispatch, getState) => {
    e.preventDefault();

    let { single_branch } = getState().branch;

    $('.btn-save').attr('disabled', 'disabled').html('Saving...');

    dispatch(setMUIPage(1));

    BranchService.branchPost(single_branch)
        .then((res) => {
            switch (res.data.status) {
                case 0:
                    ToastDanger(res.data.errors);
                    break;
                case 1:
                    if (pageOrigin == 'branch') {
                        dispatch(setPage('main_page'));
                        dispatch(clearBranch());
                    }

                    ToastSuccess(res.data.message);
                    break;
                default:
                    break;
            }

            $('.btn-save').removeAttr('disabled').html('Save');
        })
        .catch((error) => {
            if (error.data.errors.length > 0) {
                error.data.errors.map((err) => ToastDanger(err));
            } else {
                // ToastDanger("Network error, please reload the page.");
            }
            $('.btn-save').removeAttr('disabled').html('Save');
            console.log(error);
        });
};

// update
export const branchUpdate = (e) => async (dispatch, getState) => {
    e.preventDefault();

    let { single_branch } = getState().branch;

    $('.btn-save').attr('disabled', 'disabled').html('Saving...');
    BranchService.updateSingleBranch(single_branch, single_branch._id)
        .then((res) => {
            switch (res.data.status) {
                case 0:
                    ToastDanger(res.data.errors);
                    break;
                case 1:
                    dispatch(setPage('main_page'));
                    ToastSuccess(res.data.message);
                    dispatch(clearBranch());
                    break;
                default:
                    break;
            }
            $('.btn-save').removeAttr('disabled').html('Save');
        })
        .catch((error) => {
            if (error.data.errors.length > 0) {
                error.data.errors.map((err) => ToastDanger(err));
            } else {
                // ToastDanger("Network error, please reload the page.");
            }
            $('.btn-save').removeAttr('disabled').html('Save');
            console.log(error);
        });
};

export const setDynamicLoading = (key, status) => async (dispatch) => {
    dispatch({ type: SET_DYNAMIC_LOADING, payload: { key, status } });
};

// archive
export const moveToBranchArchives = () => async (dispatch, getState) => {
    let { rows_to_delete } = getState().branch;
    let id_arr = [];
    rows_to_delete.map((row) => {
        id_arr.push(row.id);
    });

    let params = {
        ids: JSON.stringify(id_arr),
    };

    BranchService.ArchiveBranch(params)
        .then((res) => {
            dispatch(setRowChecked());
            ToastSuccess(res.data.message);
            dispatch(clearBranch());
            dispatch(getBranches());
        })
        .catch((error) => {
            console.log(error);
        });
};

// archive single
export const archive = () => async (dispatch, getState) => {
    let { single_branch } = getState().branch;
    SwalWarning(
        'Warning!',
        `Do you want to remove Branch: ${single_branch.name}?`,
        () => dispatch(moveToBranchArchives())
    );
};

// handle the upload file input
export const addFile = (fileSelected) => async (dispatch, getState) => {
    if (fileSelected) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let { uploads } = getState().branch.single_branch;

    if (uploads.some((upload) => upload.name === fileSelected[0].name)) {
        ToastDanger('Sorry duplicate files are not allowed.');
    } else {
        dispatch({ type: BRANCH_ADD_FILE, payload: fileSelected });
    }
};

// handle the upload file on update
export const updateFile = (fileSelected) => async (dispatch, getState) => {
    if (fileSelected) {
        dispatch(blockRoute(true));
    } else {
        dispatch(blockRoute(false));
    }

    let {
        new_uploads,
        single_branch: { uploads },
    } = getState().branch;

    if (new_uploads.some((upload) => upload.name == fileSelected[0].name)) {
        ToastDanger('Sorry duplicate files are not allowed.');
    } else {
        dispatch({ type: BRANCH_UPDATE_FILE, payload: fileSelected });
    }
};

// clear the file input value
export const removeFile =
    (name, status, id = null) =>
    async (dispatch) => {
        if (status || name) {
            dispatch(blockRoute(true));
        } else {
            dispatch(blockRoute(false));
        }

        if (status == 'old') {
            SwalWarning(
                'Warning!',
                'Are you sure you want to remove this file?',
                () => {
                    dispatch({ type: BRANCH_UPLOADS_TO_REMOVE, payload: id });
                    dispatch(uploadFiles());
                }
            );
        } else {
            SwalWarning(
                'Warning!',
                'Are you sure you want to remove this file?',
                () => {
                    dispatch({
                        type: BRANCH_REMOVE_FILE,
                        payload: { name: name, status: status },
                    });
                }
            );
        }
    };

// clear the file input value (edit)
export const removeFileEdit =
    (name, status, id = null) =>
    async (dispatch) => {
        if (status == 'old') {
            dispatch({ type: BRANCH_UPLOADS_TO_REMOVE, payload: id });
        }

        dispatch({
            type: BRANCH_REMOVE_FILE,
            payload: { name: name, status: status },
        });
    };

export const uploadFiles = () => async (dispatch, getState) => {
    let { single_branch, new_uploads, files_to_remove } = getState().branch;

    dispatch(setDynamicLoading('upload_loading', true));

    try {
        let formdata = new FormData();
        formdata.append('branch_id', single_branch._id);

        for (const [_key, _value] of Object.entries(new_uploads)) {
            formdata.append(`new_uploads[]`, _value);
        }

        if (files_to_remove.length > 0) {
            formdata.append('files_to_remove', JSON.stringify(files_to_remove));
        }

        let res = await BranchService.uploadFiles(formdata);

        dispatch({
            type: BRANCH_GET_UPLOADED_FILES,
            payload: res.data.uploads,
        });
        ToastSuccess(res.data.message);
        dispatch(setDynamicLoading('upload_loading', false));
    } catch (err) {
        dispatch(setDynamicLoading('upload_loading', false));
        console.log(err);
    }
};

// returns selected rows only
export const getSelectedRows =
    (selectedRows, currentRows) => async (dispatch) => {
        let newArray = [];

        currentRows.map((current, i) => {
            selectedRows.map((selected, _i) => {
                if (selected.index == current.index) {
                    let selected = {
                        id: current.data[0],
                        name: current.data[1],
                    };
                    newArray.push(selected);
                }
            });
        });
        dispatch({ type: GET_ROWS_TO_DELETE, payload: newArray });
    };

export const confirmDeleteDialogBox = () => async (dispatch, getState) => {
    let { rows_to_delete } = getState().branch;
    let names = '';
    let name_arr = [];
    rows_to_delete.map((rows, i) => {
        name_arr.push('<b>' + rows.name + '</b>');
    });
    names = name_arr.join(', ');

    SwalWarningHtml(
        'Warning!',
        `Do you want to remove the Branch(es): ${names}?`,
        () => dispatch(moveToBranchArchives())
    );
};

// Sort by column name and direction
export const sortTableByColumn =
    (sort_order_name, sort_order_direction) => async (dispatch) => {
        let sortingParams = {
            sort_order_name: sort_order_name,
            sort_order_direction: sort_order_direction,
        };

        dispatch({ type: SORT_BY_COLUMN, payload: sortingParams });
        dispatch(getBranches());
    };

export const handleSearchInputMUI = (e) => async (dispatch) => {
    dispatch({ type: SEARCH_INPUT, payload: e.target.value });
};

// set the rows unchecked
export const setRowChecked = () => async (dispatch) =>
    dispatch({ type: SET_ROW_CHECKED });

// date input onchange
export const dateFilterInput = (e) => async (dispatch) => {
    dispatch({
        type: DATE_FILTER_INPUT,
        payload: { key: [e.target.name], value: e.target.value },
    });
};

// DATE INPUT CLEAR
export const dateFilterClear =
    (type, pageOrigin = null) =>
    async (dispatch) => {
        dispatch({ type: BRANCH_HISTORY_DATE_INPUT_CLEAR, payload: type });
    };

// HANDLE SUBMIT DATE FILTER
export const handleDateFilterSubmit =
    (e, filterBy, pageOrigin = null) =>
    async (dispatch, getState) => {
        e.preventDefault();

        let { date_to, date_from } = getState().branch;
        const today = new Date();

        try {
            if (
                new Date(date_from).getTime() >= today.getTime() ||
                new Date(date_to).getTime() >= today.getTime()
            ) {
                ToastDanger('Your Date value can not be greater than today.');
            }
        } catch (error) {
            console.log(`Error: ${error}`);
            ToastDanger('Something went wrong please contact your admin...');
        }
    };

// search admin users by admin_name
export const searchUsers = (search) => async (dispatch) => {
    if (!search) {
        dispatch({ type: BRANCH_SET_USER_OPTIONS, payload: [] });
        return;
    }

    BranchService.searchUser(search)
        .then((res) => {
            if (res.data.status === 1) {
                const options = res.data.users.map((user) => ({
                    value: user._id,
                    label: `${user.admin_name} ${user.lname || ''}`.trim(),
                    user,
                }));
                dispatch({ type: BRANCH_SET_USER_OPTIONS, payload: options });
            } else {
                dispatch({ type: BRANCH_SET_USER_OPTIONS, payload: [] });
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch({ type: BRANCH_SET_USER_OPTIONS, payload: [] });
        });
};

// auto-fill branch fields from selected user
export const handleSelectUser = (option) => async (dispatch) => {
    if (!option) {
        dispatch({ type: BRANCH_AUTO_FILL, payload: {} });
        return;
    }

    const { user } = option;
    const settings = user.subscriber_settings || {};

    const autoFillData = {
        branch_user_id: user._id,
        name: user.admin_name || '',
        business_name: settings.company_name || '',
        street1: settings.company_address || '',
        street2: '',
        city: '',
        state: '',
        country: {},
        email: settings.company_email || user.admin_email || '',
        mobile: settings.company_mobile || user.contact_number || '',
        landline: settings.company_landline || '',
        fax: '',
        tin: settings.company_tin || '',
        contact_person: `${user.admin_name || ''} ${user.lname || ''}`.trim(),
        uploads: [],
    };

    dispatch({ type: BRANCH_AUTO_FILL, payload: autoFillData });
};
